export const questions = {
  "1. Special Healthcare Needs": [
    {
      id: 110001,
      question: "What is the definition of disability given in the chapter?",
      options: [
        "A physical or mental impairment that substantially limits one or more life activities",
        "A temporary condition affecting only physical strength",
        "A condition that exists only from birth",
        "A legal status granted only by a government agency"
      ],
      correctAnswer: 0
    },
    {
      id: 110002,
      question: "What are \"major life activities\" as defined in the chapter?",
      options: [
        "Activities related solely to employment status",
        "Activities that the average person can perform with little or no difficulty",
        "Activities performed only by healthcare workers",
        "Activities requiring specialized medical training"
      ],
      correctAnswer: 1
    },
    {
      id: 110003,
      question: "Which statement about disabilities is accurate according to the chapter?",
      options: [
        "Disabilities are always apparent to any observer",
        "Disabilities are identical in needs across all individuals",
        "Disabilities can be hidden or apparent on observation",
        "Disabilities are limited only to physical mobility issues"
      ],
      correctAnswer: 2
    },
    {
      id: 110004,
      question: "Which national health policy from 1973 is mentioned in the chapter?",
      options: [
        "Affordable Care Act",
        "Olmstead Decision",
        "New Freedom Initiative",
        "Rehabilitation Act"
      ],
      correctAnswer: 3
    },
    {
      id: 110005,
      question: "Which decision from 1999 is listed among the national health policies affecting disability?",
      options: [
        "Olmstead Decision",
        "Rehabilitation Act",
        "New Freedom Initiative",
        "Affordable Care Act"
      ],
      correctAnswer: 0
    },
    {
      id: 110006,
      question: "Which initiative from 2001 is listed among the national health policies affecting disability?",
      options: [
        "Rehabilitation Act",
        "New Freedom Initiative",
        "Olmstead Decision",
        "Affordable Care Act"
      ],
      correctAnswer: 1
    },
    {
      id: 110007,
      question: "Which act from 2010 is listed among the national health policies affecting disability?",
      options: [
        "Rehabilitation Act",
        "Olmstead Decision",
        "Affordable Care Act",
        "New Freedom Initiative"
      ],
      correctAnswer: 2
    },
    {
      id: 110008,
      question: "What type of language does the chapter recommend using with patients who have disabilities?",
      options: [
        "Diagnosis-first language",
        "Medical jargon terminology",
        "Technical clinical terminology",
        "People-first language"
      ],
      correctAnswer: 3
    },
    {
      id: 110009,
      question: "What skill do dental hygienists need to apply when seeking informed consent from patients with disabilities?",
      options: [
        "Critical thinking skills",
        "Persuasive sales techniques",
        "Rapid decision-making skills",
        "Financial negotiation skills"
      ],
      correctAnswer: 0
    },
    {
      id: 110010,
      question: "What are the three primary dimensions of disability listed in the chapter?",
      options: [
        "Congenital, acquired, developmental",
        "Impairments, activity limitations, participation restrictions",
        "Physical, mental, emotional conditions",
        "Mobility, vision, hearing impairments"
      ],
      correctAnswer: 1
    },
    {
      id: 110011,
      question: "What is a \"participation restriction\" as described in the chapter?",
      options: [
        "A limitation in performing physical exercise routines",
        "A restriction placed by insurance providers",
        "An inability to engage in everyday life activities for reasons that may not be under the patient's control",
        "A limitation affecting only communication ability"
      ],
      correctAnswer: 2
    },
    {
      id: 110012,
      question: "How is a Disability Adjusted Life Year (DALY) best described?",
      options: [
        "The number of medical visits required annually",
        "The total income lost due to disability",
        "The total years a person lives with a disability",
        "One lost year of healthy life"
      ],
      correctAnswer: 3
    },
    {
      id: 110013,
      question: "What are congenital disabilities?",
      options: [
        "An irregularity present at birth, which may or may not be related to genetic factors",
        "Disabilities acquired through military service",
        "Disabilities typically found in people over 65 years",
        "Disabilities caused solely by later trauma"
      ],
      correctAnswer: 0
    },
    {
      id: 110014,
      question: "What are acquired disabilities?",
      options: [
        "Disabilities present only at the time of birth",
        "Disabilities present after birth that can be traceable to disease or trauma",
        "Disabilities limited only to cognitive impairment",
        "Disabilities that always resolve without treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 110015,
      question: "What are developmental disabilities?",
      options: [
        "Disabilities that occur only after age 65",
        "Disabilities related only to military service",
        "A group of conditions with impairment in physical, learning, language, or behavioral areas",
        "Disabilities that are always temporary in nature"
      ],
      correctAnswer: 2
    },
    {
      id: 110016,
      question: "Age-associated disabilities are typically found in people over what age?",
      options: [
        "50 years",
        "55 years",
        "60 years",
        "65 years"
      ],
      correctAnswer: 3
    },
    {
      id: 110017,
      question: "Which of the following is an example of an external feature of a barrier-free environment?",
      options: [
        "Parking",
        "Reception area",
        "Treatment room",
        "Passageways"
      ],
      correctAnswer: 0
    },
    {
      id: 110018,
      question: "Which of the following is an example of an internal feature of a barrier-free environment?",
      options: [
        "Entrance",
        "Reception area",
        "Walkways",
        "Parking"
      ],
      correctAnswer: 1
    },
    {
      id: 110019,
      question: "What is a major health policy and programmatic barrier for people with disabilities?",
      options: [
        "Excessive availability of public transportation",
        "Overabundance of trained healthcare providers",
        "Affordability of healthcare services",
        "Too many accessible public accommodations"
      ],
      correctAnswer: 2
    },
    {
      id: 110020,
      question: "What is a common attitudinal barrier faced by people with disabilities?",
      options: [
        "Excessive availability of dental appointments",
        "Overqualification of healthcare professionals",
        "Too much accessible transportation",
        "Fear of interacting with patients with disabilities among providers"
      ],
      correctAnswer: 3
    },
    {
      id: 110021,
      question: "What does the ADA prohibit?",
      options: [
        "Discrimination against people with disabilities",
        "Use of mobility assistive equipment",
        "Public transportation access for all citizens",
        "Employment of people with disabilities"
      ],
      correctAnswer: 0
    },
    {
      id: 110022,
      question: "What three factors form the basis of risk assessment for patients with disabilities?",
      options: [
        "Age, gender, and income level",
        "Oral manifestations, functional ability, and medical status",
        "Insurance status, education, and employment",
        "Diet, exercise, and sleep habits"
      ],
      correctAnswer: 1
    },
    {
      id: 110023,
      question: "What should dental hygienists assess before using assistive oral self-care devices with a patient?",
      options: [
        "Patient's favorite color and hobbies",
        "Only the patient's dental insurance coverage",
        "Range of motion, grip strength, skill level, and cognitive application",
        "The patient's employment history"
      ],
      correctAnswer: 2
    },
    {
      id: 110024,
      question: "According to Box 51-1, what describes ADL/IADL Level 0?",
      options: [
        "Individuals unable to perform any oral care",
        "Individuals confined to bed and nonambulatory",
        "Individuals requiring hand-over-hand assistance",
        "Individuals capable of flossing and brushing their own teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 110025,
      question: "According to Box 51-1, what describes ADL/IADL Levels 1 and 2?",
      options: [
        "Individuals capable of carrying out at least part of their oral hygiene needs but who require considerable training, assistance, and direct supervision",
        "Individuals who are completely independent in oral care",
        "Individuals who are unable to perform their own care and are dependent",
        "Individuals who need no supervision at all"
      ],
      correctAnswer: 0
    },
    {
      id: 110026,
      question: "According to Box 51-1, what describes ADL/IADL Level 3?",
      options: [
        "Individuals capable of flossing and brushing independently",
        "Individuals who are unable to perform their own care and are therefore dependent",
        "Individuals needing only occasional verbal reminders",
        "Individuals with no functional limitations at all"
      ],
      correctAnswer: 1
    },
    {
      id: 110027,
      question: "What is the purpose of assistive devices according to the chapter?",
      options: [
        "Replace the need for dental hygiene care entirely",
        "Provide only cosmetic improvements to patients",
        "Maintain or improve an individual's functioning and independence to facilitate participation and enhance well-being",
        "Eliminate the need for caregiver assistance"
      ],
      correctAnswer: 2
    },
    {
      id: 110028,
      question: "Which of the following is an example of mobility assistive equipment?",
      options: [
        "Communication board",
        "Cognitive aid device",
        "Auditory aid device",
        "Wheelchair"
      ],
      correctAnswer: 3
    },
    {
      id: 110029,
      question: "Which professional should work with the dental hygienist to customize oral self-care assistive devices?",
      options: [
        "Occupational therapist",
        "Radiologist specialist",
        "Pharmacist consultant",
        "Anesthesiologist provider"
      ],
      correctAnswer: 0
    },
    {
      id: 110030,
      question: "What is required before using protective stabilization on a patient?",
      options: [
        "Verbal agreement from front desk staff",
        "Informed consent",
        "Approval from the patient's employer",
        "A signed liability waiver only"
      ],
      correctAnswer: 1
    },
    {
      id: 110031,
      question: "For which patients should protective stabilization devices be used with caution?",
      options: [
        "Patients with excellent balance",
        "Patients who are fully ambulatory",
        "Patients prone to seizures",
        "Patients with no medical history"
      ],
      correctAnswer: 2
    },
    {
      id: 110032,
      question: "Why should dental hygienists limit the use of water or other fluids for patients with increased aspiration risk?",
      options: [
        "To save on material costs",
        "Because fluids stain dental instruments",
        "Because it slows down treatment time",
        "Because these patients are at increased risk for aspiration"
      ],
      correctAnswer: 3
    },
    {
      id: 110033,
      question: "When escorting a visually impaired individual, what technique is depicted in the chapter's figure?",
      options: [
        "Allowing the patient to hold the escort's arm while walking slightly behind",
        "Leading the patient by pushing them forward",
        "Using only verbal directions without contact",
        "Having the patient walk several feet ahead independently"
      ],
      correctAnswer: 0
    },
    {
      id: 110034,
      question: "What is a potential complication during wheelchair transfers related to pressure?",
      options: [
        "Muscular strength improvement",
        "Pressure injury",
        "Increased mobility overall",
        "Improved blood circulation"
      ],
      correctAnswer: 1
    },
    {
      id: 110035,
      question: "Approximately how often should a patient be repositioned to help manage wheelchair transfer complications?",
      options: [
        "Every 5 minutes",
        "Every 10 minutes",
        "Approximately every 20 minutes",
        "Every 60 minutes"
      ],
      correctAnswer: 2
    },
    {
      id: 110036,
      question: "What can help facilitate workplace modifications for dental hygienists who have a disability?",
      options: [
        "Reducing patient caseload permanently",
        "Avoiding clinical work entirely",
        "Relying solely on government subsidies",
        "Adaptive technology, tax incentives for accessibility construction, and creative thinking"
      ],
      correctAnswer: 3
    },
    {
      id: 110037,
      question: "Documentation for a patient with a disability should include which of the following?",
      options: [
        "Individualized information about the patient's condition or level of functioning affecting care modifications",
        "Only the patient's billing address",
        "The patient's favorite dental products",
        "General population statistics on disabilities"
      ],
      correctAnswer: 0
    },
    {
      id: 110038,
      question: "What should instruction for caregivers emphasize according to the chapter?",
      options: [
        "Discouraging patient involvement in their own oral care",
        "Encouraging personal oral care and improving caregiver knowledge of techniques",
        "Avoiding any caregiver training",
        "Focusing solely on dietary restrictions"
      ],
      correctAnswer: 1
    },
    {
      id: 110039,
      question: "What is a purpose of group in-service education programs described in the chapter?",
      options: [
        "Replacing individualized patient care entirely",
        "Limiting access to dental hygiene services",
        "Providing continuing education and follow-up for caregivers and staff",
        "Reducing the need for documentation"
      ],
      correctAnswer: 2
    },
    {
      id: 110040,
      question: "How can dental hygienists advocate for patients with disabilities?",
      options: [
        "By avoiding community involvement",
        "By limiting patient education efforts",
        "By discouraging leadership roles in professional organizations",
        "By participating on councils, boards, and support groups, and via speaking engagements and publications"
      ],
      correctAnswer: 3
    },
    {
      id: 110041,
      question: "Protective stabilization is considered a basic dental hygiene procedure that requires no informed consent.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 110042,
      question: "When preparing a dental operatory for a wheelchair transfer, the dental hygienist should remove the dental chair armrest and relocate equipment such as hoses and foot controls from the transfer path.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 110043,
      question: "Most disabilities are considered an obstacle to dental hygiene licensure and the provision of clinical patient care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 110044,
      question: "Rubber dam isolation can help prevent aspiration of dental materials in patients who are at increased risk for aspiration.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "2. The Cardiovascular Client": [
    {
      id: 110045,
      question: "Which population of health care recipients does this chapter indicate is frequently encountered in dental settings?",
      options: [
        "Patients with cardiovascular disease",
        "Patients recovering from orthopedic surgery",
        "Patients undergoing cancer chemotherapy",
        "Patients with untreated vision impairment"
      ],
      correctAnswer: 0
    },
    {
      id: 110046,
      question: "According to current data cited in the chapter, the risk of cardiovascular disease is slightly higher in individuals with which condition?",
      options: [
        "Seasonal allergies",
        "Periodontal disease",
        "Lactose intolerance",
        "Mild vitamin D deficiency"
      ],
      correctAnswer: 1
    },
    {
      id: 110047,
      question: "What percentage of patients who had COVID-19 may experience myocardial injury and arrhythmias, according to the chapter?",
      options: [
        "5% to 10%",
        "50% to 60%",
        "20% to 30%",
        "70% to 80%"
      ],
      correctAnswer: 2
    },
    {
      id: 110048,
      question: "What is described as the leading cause of death worldwide in this chapter?",
      options: [
        "Respiratory infection",
        "Periodontal disease",
        "Accidental injury",
        "Cardiovascular disease"
      ],
      correctAnswer: 3
    },
    {
      id: 110049,
      question: "Which term describes cardiovascular risk factors that cannot be changed?",
      options: [
        "Nonmodifiable risk factors",
        "Reversible risk factors",
        "Temporary risk factors",
        "Adjustable risk factors"
      ],
      correctAnswer: 0
    },
    {
      id: 110050,
      question: "Under the anatomic classification of cardiovascular disease, which structures of the heart are specifically listed?",
      options: [
        "Only the aorta and pulmonary artery",
        "Pericardium, myocardium, endocardium, and heart valves",
        "Only the left and right atria",
        "Only the coronary arteries"
      ],
      correctAnswer: 1
    },
    {
      id: 110051,
      question: "Under the etiologic classification of cardiovascular disease, which of the following is listed as a cause?",
      options: [
        "Dietary fiber deficiency",
        "Excessive fluoride exposure",
        "Congenital anomalies",
        "Seasonal temperature change"
      ],
      correctAnswer: 2
    },
    {
      id: 110052,
      question: "According to the chapter, what is needed before an indisputable causative relationship between periodontal disease and cardiovascular disease can be established?",
      options: [
        "A change in dental insurance policy",
        "New antibiotic formulations",
        "Updated periodontal probing instruments",
        "More evidence"
      ],
      correctAnswer: 3
    },
    {
      id: 110053,
      question: "Infective endocarditis is characterized by the formation of what on the heart valves or endocardium?",
      options: [
        "Bacterial vegetations",
        "Calcified plaque deposits",
        "Fatty fibrous tissue",
        "Scar tissue nodules"
      ],
      correctAnswer: 0
    },
    {
      id: 110054,
      question: "What are the two types of infective endocarditis mentioned in the chapter?",
      options: [
        "Primary and secondary",
        "Acute and subacute",
        "Localized and systemic",
        "Congenital and acquired"
      ],
      correctAnswer: 1
    },
    {
      id: 110055,
      question: "What must be considered when scheduling appointments for a patient with infective endocarditis risk who requires antibiotics?",
      options: [
        "The dental office's daily patient volume",
        "The time of year the appointment occurs",
        "The patient's prescribed prophylactic antibiotic regimen",
        "The patient's preferred appointment color scheme"
      ],
      correctAnswer: 2
    },
    {
      id: 110056,
      question: "Which of the following is listed as a type of congenital heart defect in the chapter?",
      options: [
        "Rheumatic valve syndrome",
        "Coronary insufficiency",
        "Hypertensive crisis",
        "Ventricular septal defect"
      ],
      correctAnswer: 3
    },
    {
      id: 110057,
      question: "Which structure is affected in a patent ductus arteriosus?",
      options: [
        "An abnormal connection between the aorta and pulmonary artery",
        "A hole between the two atria only",
        "A malformed tricuspid valve",
        "A narrowing of the aortic valve"
      ],
      correctAnswer: 0
    },
    {
      id: 110058,
      question: "Dental hygiene care for a patient with congenital heart disease should include which of the following?",
      options: [
        "Avoidance of all dental radiographs permanently",
        "Physician consultation to confirm drug usage and current medical status",
        "Immediate referral to cardiac surgery before any cleaning",
        "Discontinuation of all the patient's prescribed medications"
      ],
      correctAnswer: 1
    },
    {
      id: 110059,
      question: "Valvular heart defects are commonly associated with which condition?",
      options: [
        "Seasonal influenza",
        "Vitamin deficiency",
        "Rheumatic fever",
        "Chronic sinusitis"
      ],
      correctAnswer: 2
    },
    {
      id: 110060,
      question: "What type of daily oral care is necessary for patients with valvular heart defects?",
      options: [
        "Avoidance of all brushing and flossing",
        "Use of whitening products only",
        "Weekly professional cleanings only",
        "Meticulous daily oral biofilm control"
      ],
      correctAnswer: 3
    },
    {
      id: 110061,
      question: "What is described as the most destructive effect of rheumatic heart disease?",
      options: [
        "Carditis",
        "Xerostomia",
        "Gingival enlargement",
        "Bradycardia"
      ],
      correctAnswer: 0
    },
    {
      id: 110062,
      question: "According to the chapter, is prophylactic antibiotic premedication required for rheumatic heart disease patients?",
      options: [
        "Yes, it is always required",
        "No, it is not required",
        "Only required for children",
        "Only required after age 60"
      ],
      correctAnswer: 1
    },
    {
      id: 110063,
      question: "In mitral valve prolapse, what happens when the mitral valve leaflets are damaged?",
      options: [
        "The valve fuses permanently shut, blocking all blood flow",
        "The valve calcifies and cannot open at all",
        "The leaflet may flop or bulge backward into the left atrium, causing regurgitation",
        "The leaflet detaches completely from the heart wall"
      ],
      correctAnswer: 2
    },
    {
      id: 110064,
      question: "What is the current American Heart Association recommendation regarding antibiotic prophylaxis for mitral valve prolapse patients undergoing dental treatment?",
      options: [
        "Antibiotic prophylaxis is required for every appointment",
        "Antibiotic prophylaxis is required only for extractions",
        "Antibiotic prophylaxis is required only for children",
        "Antibiotic prophylaxis is no longer recommended"
      ],
      correctAnswer: 3
    },
    {
      id: 110065,
      question: "Hypertension is often referred to by which nickname in the chapter?",
      options: [
        "The silent killer",
        "The quiet epidemic",
        "The hidden threat",
        "The invisible disease"
      ],
      correctAnswer: 0
    },
    {
      id: 110066,
      question: "What are the two etiologic categories of hypertension described in the chapter?",
      options: [
        "Acute and chronic",
        "Primary and secondary",
        "Mild and severe",
        "Congenital and acquired"
      ],
      correctAnswer: 1
    },
    {
      id: 110067,
      question: "Hypertensive cardiovascular disease is defined as a persistent elevation of which measurements?",
      options: [
        "Heart rate and respiratory rate",
        "Blood glucose and cholesterol levels",
        "Systolic and diastolic blood pressures",
        "Oxygen saturation and body temperature"
      ],
      correctAnswer: 2
    },
    {
      id: 110068,
      question: "Care plan considerations for patients with controlled hypertension should focus on what?",
      options: [
        "Increasing appointment length significantly",
        "Eliminating the use of local anesthetics entirely",
        "Scheduling appointments only on weekends",
        "Stress reduction strategies"
      ],
      correctAnswer: 3
    },
    {
      id: 110069,
      question: "Ischemic heart disease arises from what underlying problem?",
      options: [
        "Reduction or arrest of blood supply to the myocardium",
        "Excessive blood flow to the myocardium",
        "Inflammation of the pericardial sac only",
        "Overproduction of red blood cells"
      ],
      correctAnswer: 0
    },
    {
      id: 110070,
      question: "What is identified as the main cause of ischemic heart disease?",
      options: [
        "Viral myocarditis",
        "Atherosclerosis",
        "Congenital valve defects",
        "Chronic anemia"
      ],
      correctAnswer: 1
    },
    {
      id: 110071,
      question: "Which of the following is listed as a manifestation of ischemic heart disease?",
      options: [
        "Tetralogy of Fallot",
        "Patent ductus arteriosus",
        "Angina pectoris",
        "Ventricular septal defect"
      ],
      correctAnswer: 2
    },
    {
      id: 110072,
      question: "Angina pectoris is described as chest pain triggered by physical exertion that is relieved by rest or by what, within about five minutes?",
      options: [
        "Oral acetaminophen",
        "Topical benzocaine",
        "Inhaled albuterol",
        "Sublingual nitroglycerin"
      ],
      correctAnswer: 3
    },
    {
      id: 110073,
      question: "If a patient's angina pectoris symptoms are not relieved by nitroglycerin, what should be activated?",
      options: [
        "The emergency medical system (911)",
        "The office's routine recall reminder system",
        "The patient's dental insurance provider",
        "The patient's next scheduled cleaning appointment"
      ],
      correctAnswer: 0
    },
    {
      id: 110074,
      question: "Which of the following is listed as another name for myocardial infarction in the chapter?",
      options: [
        "Atrial fibrillation",
        "Coronary thrombosis",
        "Rheumatic carditis",
        "Mitral stenosis"
      ],
      correctAnswer: 1
    },
    {
      id: 110075,
      question: "A myocardial infarction can result from a sudden reduction or arrest of coronary blood flow or from what other cause?",
      options: [
        "Excess saliva production",
        "Overuse of fluoride varnish",
        "Persistent vasospasm in a coronary artery",
        "Mild dehydration"
      ],
      correctAnswer: 2
    },
    {
      id: 110076,
      question: "Which of the following is one of the four disorders associated with coronary heart disease listed in the chapter?",
      options: [
        "Gingival enlargement",
        "Xerostomia",
        "Patent ductus arteriosus",
        "Coronary insufficiency"
      ],
      correctAnswer: 3
    },
    {
      id: 110077,
      question: "According to the chapter, what is the last manifestation of coronary heart disease?",
      options: [
        "Sudden death",
        "Mild chest discomfort",
        "Gingival bleeding",
        "Temporary dizziness"
      ],
      correctAnswer: 0
    },
    {
      id: 110078,
      question: "Congestive heart failure (CHF) results in the heart's inability to do what?",
      options: [
        "Generate any electrical impulses at all",
        "Pump blood at a rate necessary to meet the oxygen needs of body tissues",
        "Produce enough red blood cells for circulation",
        "Maintain a constant body temperature"
      ],
      correctAnswer: 1
    },
    {
      id: 110079,
      question: "Which type of heart failure involves difficulty receiving oxygenated blood from the lungs?",
      options: [
        "Right-sided heart failure",
        "Congenital heart failure",
        "Left-sided heart failure",
        "Valvular heart failure"
      ],
      correctAnswer: 2
    },
    {
      id: 110080,
      question: "Which type of heart failure is associated with systemic venous congestion and peripheral edema?",
      options: [
        "Left-sided heart failure",
        "Ischemic heart failure",
        "Rheumatic heart failure",
        "Right-sided heart failure"
      ],
      correctAnswer: 3
    },
    {
      id: 110081,
      question: "For patients with congestive heart failure, what adjustment may be needed during dental treatment to support breathing?",
      options: [
        "Patient positioning may need to be adjusted",
        "The dental chair must remain fully reclined at all times",
        "All local anesthetics must be withheld",
        "The appointment must be rescheduled indefinitely"
      ],
      correctAnswer: 0
    },
    {
      id: 110082,
      question: "Cardiac arrhythmias are described as an interruption of what within the heart?",
      options: [
        "The supply of oxygen to the lungs",
        "The conduction of impulses, causing a delay or block",
        "The flow of saliva in the oral cavity",
        "The formation of red blood cells"
      ],
      correctAnswer: 1
    },
    {
      id: 110083,
      question: "Which of the following is listed as a common cardiac dysrhythmia in the chapter?",
      options: [
        "Gingival hyperplasia",
        "Xerostomia",
        "Atrial fibrillation",
        "Mitral valve prolapse"
      ],
      correctAnswer: 2
    },
    {
      id: 110084,
      question: "For patients with pacemakers, what type of dental instruments and devices should be used to avoid functional interference?",
      options: [
        "Only battery-powered ultrasonic scalers",
        "Only devices with wireless Bluetooth connectivity",
        "Only devices requiring high-voltage current",
        "Nonelectrical alternatives to electric-powered instruments"
      ],
      correctAnswer: 3
    },
    {
      id: 110085,
      question: "Prophylactic antibiotic premedication is required for how long after pacemaker implantation, according to the chapter?",
      options: [
        "The first 6 months after implantation",
        "The first 6 weeks after implantation",
        "Permanently, for the life of the pacemaker",
        "Only on the day of implantation"
      ],
      correctAnswer: 0
    },
    {
      id: 110086,
      question: "According to the chapter, what percentage of the risks for myocardial infarction and stroke are modifiable?",
      options: [
        "50%",
        "90%",
        "25%",
        "10%"
      ],
      correctAnswer: 1
    },
    {
      id: 110087,
      question: "Which of the following is listed as a lifestyle modification to reduce cardiovascular risk?",
      options: [
        "Increasing red meat consumption",
        "Reducing physical activity",
        "Tobacco cessation",
        "Increasing sodium intake"
      ],
      correctAnswer: 2
    },
    {
      id: 110088,
      question: "Which surgical procedure is described using internal mammary artery or vein grafts to reroute blood around a narrowed coronary artery?",
      options: [
        "Cardiac resynchronization therapy",
        "Angioplasty",
        "Cardiac catheterization",
        "Coronary artery bypass grafting"
      ],
      correctAnswer: 3
    },
    {
      id: 110089,
      question: "Which of the following devices is implanted to help regulate abnormal heart rhythms, as shown in the chapter's cardiac pacemaker figure?",
      options: [
        "A cardiac pacemaker with leads placed via the subclavian vein",
        "A coronary stent placed in the aorta",
        "A cardioverter defibrillator placed in the wrist",
        "A ventricular septal patch placed externally"
      ],
      correctAnswer: 0
    },
    {
      id: 110090,
      question: "Which of the following is listed as a type of cardiovascular surgery in the chapter?",
      options: [
        "Gingivectomy",
        "Angioplasty",
        "Root planing",
        "Sealant placement"
      ],
      correctAnswer: 1
    },
    {
      id: 110091,
      question: "Anticoagulant therapy is used to prevent the occurrence or recurrence of what?",
      options: [
        "Gingival inflammation and bleeding",
        "Dental caries and enamel erosion",
        "Blood clots that can cause MI or stroke",
        "Xerostomia and oral candidiasis"
      ],
      correctAnswer: 2
    },
    {
      id: 110092,
      question: "What advantage do direct oral anticoagulants (DOACs) offer compared to older anticoagulants, according to the chapter?",
      options: [
        "No need for any dental management considerations",
        "Complete elimination of stroke risk",
        "No monitoring required for any medical condition",
        "More targeted action and less bleeding risk"
      ],
      correctAnswer: 3
    },
    {
      id: 110093,
      question: "Antiplatelet therapy works by preventing what process?",
      options: [
        "The aggregation of platelets, or the ability of blood to clot",
        "The production of red blood cells in bone marrow",
        "The absorption of calcium in the small intestine",
        "The release of saliva from the salivary glands"
      ],
      correctAnswer: 0
    },
    {
      id: 110094,
      question: "Most medications used to treat hypertension are associated with which oral side effect?",
      options: [
        "Excessive salivation",
        "Xerostomia",
        "Enamel hypoplasia",
        "Tooth discoloration only"
      ],
      correctAnswer: 1
    },
    {
      id: 110095,
      question: "Which class of cardiovascular medications may contribute to gingival enlargement, according to the chapter?",
      options: [
        "Beta blockers",
        "Diuretics",
        "Calcium channel blockers",
        "Statins"
      ],
      correctAnswer: 2
    },
    {
      id: 110096,
      question: "Documentation for a cardiovascular patient should include responses to health history questions about what?",
      options: [
        "The patient's preferred toothpaste brand",
        "The patient's dental insurance premium amount",
        "The distance the patient traveled to the appointment",
        "Visitations to the cardiologist and physician updates"
      ],
      correctAnswer: 3
    },
    {
      id: 110097,
      question: "Which condition places a patient at increased risk for life-threatening medical emergencies, according to the chapter's emergency prevention section?",
      options: [
        "Congestive heart failure",
        "Mild seasonal allergies",
        "Occasional tension headaches",
        "Minor canker sores"
      ],
      correctAnswer: 0
    },
    {
      id: 110098,
      question: "What is identified as the most life-threatening cardiac emergency in the chapter?",
      options: [
        "Mild heart palpitations",
        "Cardiac arrest",
        "Slight elevation in blood pressure",
        "Temporary lightheadedness"
      ],
      correctAnswer: 1
    },
    {
      id: 110099,
      question: "Which signs may indicate a potential cardiac emergency during a dental appointment?",
      options: [
        "A slightly elevated body temperature only",
        "A minor increase in appetite",
        "Muscular tenseness, perspiration, and verbal cues",
        "Mild seasonal skin dryness"
      ],
      correctAnswer: 2
    },
    {
      id: 110100,
      question: "What should be assessed and addressed through good communication to help minimize a cardiovascular patient's anxiety about treatment?",
      options: [
        "The patient's employment history",
        "The patient's preferred appointment day of the week",
        "The patient's dietary preferences unrelated to cardiovascular health",
        "Dental anxiety"
      ],
      correctAnswer: 3
    },
    {
      id: 110101,
      question: "Cardiovascular disease includes conditions and diseases affecting the heart and blood vessels.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 110102,
      question: "The chapter states that a definitive, indisputable causative relationship between periodontal disease and cardiovascular disease has already been firmly established with no further evidence needed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 110103,
      question: "Prophylactic antibiotic premedication is required for patients with rheumatic heart disease according to this chapter.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 110104,
      question: "The American Heart Association no longer recommends antibiotic prophylaxis during dental treatment for patients with mitral valve prolapse.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 110105,
      question: "According to the chapter, about 90% of the risks for myocardial infarction and stroke are modifiable.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 110106,
      question: "Nonelectrical alternatives to electric-powered dental instruments should be used for patients with pacemakers to avoid functional interference.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 110107,
      question: "Left-sided heart failure is associated with systemic venous congestion and peripheral edema, while right-sided heart failure causes difficulty receiving oxygenated blood from the lungs.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
